import { AxiosRequestConfig } from "axios";
import ApiResponse, { isError } from "utils/api/models/api-response";
import ApiService from "utils/api/api-service";
import { ApiErrorNotification } from "utils/ui/notificationService";

class WorkScheduleService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: process.env.REACT_APP_API_URL,
      ...config,
    });
  }
    public async createOfficalHolidays(data: any): Promise<any> {
    return this.post(`/api/holidays`, data);
    }
  public async getOfficalHolidays(page: string, search?: string): Promise<any> {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('items_per_page', '18');
    if (search) params.append('filter[search]', search);

    return this.get(`/api/holidays?${params.toString()}`);
  }
  public async createTechnicalWorkSchedule(data: any): Promise<any> {
  return this.post(`/api/technicalSchedules`, data);
  }
  public async updateTechnicalWorkSchedule(data: any): Promise<any> {
  return this.put(`/api/technicalSchedules`, data);
  }
  public async getTechnicalWorkSchedule(page: string, search?: string): Promise<any> {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('items_per_page', '6');
    if (search) params.append('filter[search]', search);
    return this.get(`/api/technicalSchedules?${params.toString()}`);
  }
  public async createCheckInAttendanceLog(data: any): Promise<any> {
  return this.post(`/api/attendance/check-in`, data);
  }
  public async createCheckOutAttendanceLog(data: any): Promise<any> {
  return this.post(`/api/attendance/check-out`, data);
  }
  public async getAttendanceLog(filters: { user_id?: number; search?: string }): Promise<any> {
    const queryParts: string[] = [];
    if (filters.user_id !== undefined) queryParts.push(`filter[user_id]=${filters.user_id}`);
    if (filters.search) queryParts.push(`filter[search]=${encodeURIComponent(filters.search)}`);
    const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
    return this.get(`/api/attendanceLogs${queryString}`);
  }
  public async updateCheckTimeAttendanceLog(data: any, id:number): Promise<any> {
    return this.put(`/api/attendance/update/${id}`, data);
  }
  public async createVacation(data: any): Promise<any> {
    return this.post(`/api/vacationRequests`, data);
  }
  public async getMyVacation(page: string, search?: string): Promise<any> {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('items_per_page', '6');
    return this.get(`/api/getMyVacations?${params.toString()}`);
  }
  public async getVacationList(
    page: string,
    search?: string,
    status?: string
  ): Promise<any> {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('items_per_page', '6');
    if (search) params.append('search', search);
    return this.get(status ? `/api/vacationRequests?${params.toString()}&filter[status]=${status}` : `/api/vacationRequests?${params.toString()}`);
  }
  public async acceptOrRejectVacation(vacationId: number, status: number): Promise<any> {
    return this.put(`/api/vacationRequests/${vacationId}`, {status: status});
  }
  public async getEmployeeWorkReports(page: number, perPage: number): Promise<any> {
    return this.get(`/api/WorkScheduleReport?page=${page}&items_per_page=${perPage}`);
  }
}

const workScheduleService = new WorkScheduleService();

export const CreateOfficalHolidays = async (data: any) => {
  const result: any = await workScheduleService.createOfficalHolidays(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetOfficalHolidays = async (page: any, search: any) => {
  const result: any = await workScheduleService.getOfficalHolidays(page, search);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const CreateTechnicalWorkSchedule = async (data: any) => {
  const result: any = await workScheduleService.createTechnicalWorkSchedule(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};

export const UpdateTechnicalWorkSchedule = async (data: any) => {
  const result: any = await workScheduleService.updateTechnicalWorkSchedule(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetTechnicalWorkSchedule = async (page: any, search: any) => {
  const result: any = await workScheduleService.getTechnicalWorkSchedule(page, search);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const CreateCheckInAttendanceLog = async (data: any) => {
  const result: any = await workScheduleService.createCheckInAttendanceLog(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const CreateCheckOutAttendanceLog = async (data: any) => {
  const result: any = await workScheduleService.createCheckOutAttendanceLog(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetAttendanceLog = async (filters: { user_id?: number; search?: string }) => {
  const result: any = await workScheduleService.getAttendanceLog(filters);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const UpdateCheckTimeAttendanceLog = async (data: any, id: number) => {
  const result: any = await workScheduleService.updateCheckTimeAttendanceLog(data, id);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const CreateVacation = async (data: any) => {
  const result: any = await workScheduleService.createVacation(data);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetMyVacation = async (page: any) => {
  const result: any = await workScheduleService.getMyVacation(page);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetVacationList = async (page: any, search: any, status?: string) => {
  const result: any = await workScheduleService.getVacationList(page, search, status);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const AcceptOrRejectVacation = async (vacationId: number, status: number) => {
  const result: any = await workScheduleService.acceptOrRejectVacation(vacationId, status);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};
export const GetEmployeeWorkReports = async (page: number,perPage: number) => {
  const result: any = await workScheduleService.getEmployeeWorkReports(page, perPage);
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};